var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"bar-toggle",class:{ open: _vm.open },on:{"click":_vm.onOpenToggle}},[_c('icon',{attrs:{"name":_vm.open ? 'minus' : 'bars'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }